import { useState } from 'react'
import { string, array, func } from 'prop-types';
import { Form, Col } from 'react-bootstrap';
import { Select, Tooltip } from 'antd';
import moment from 'moment';
import InputComp from 'components/InputComp';

interface SelectArray {
    value: string
    label: string
}

interface InputCustomProps {
    title: string
    name: string
    type: string
    value: string
    asset_id: number
    project_id: number
    select: SelectArray[]
    handleSelect: (value: string, name: string) => void
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void 
}

const InputCustom = ({
    title, name, type, asset_id,
    select = [], handleSelect,
    handleChange,project_id, value
}: InputCustomProps) => {
    const [loading, setLoading] = useState(false); 
    const [isEditing, setIsEditing] = useState(false); 

    const toggleEdit = () => setIsEditing(prev => !prev);
    const handleOpenPdf = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER}/projects/${project_id}/assets_its/${asset_id}/download`);
            if (!response.ok) throw new Error('Error al obtener el PDF');
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        } catch (error) {
            console.error('Error al abrir el PDF:', error);
        } finally {
            setLoading(false);
        }
    };

    const renderEditableField = (onChangeHandler: InputCustomProps["handleChange"]) => (
        <div className="edit__and__cancel__form">
            <InputComp
                type={type}
                title={title}
                name={name}
                onChange={onChangeHandler}
            />
            {isEditing && <Tooltip title="Cancelar"><span className='cancel__icon' onClick={toggleEdit}></span> </Tooltip>}
        </div>
    );

    const renderReadOnlyField = (content: React.ReactNode) => (
        <Form.Group as={Col}>
            <Form.Label style={{ fontWeight: "600" }} >{title}</Form.Label>
            <div className="value__form__extras">
                {content}
                {(value || isEditing) && <Tooltip title="Editar"><span className='edit__icon' onClick={toggleEdit}></span></Tooltip>}
            </div>
        </Form.Group>
    );

    const components = {
        date: (!value || isEditing)
            ? renderEditableField(handleChange)
            : renderReadOnlyField(moment(value).format('LL')),

        file: (!value || isEditing)
            ? renderEditableField(handleChange)
            : <Form.Group as={Col}>
                <Form.Label style={{ fontWeight: "600" }}>{title}</Form.Label>
                <div style={{ display: 'flex', alignItems: 'center', gap: 30 }}>
                    <a
                        className={`invoice__file__pdf ${loading ? 'invoice__file__pdf__load' : ''}`}
                        onClick={handleOpenPdf}
                        role="button"
                    ></a>
                    <span className="value__form__extras">
                        <Tooltip title="Editar">
                            <span className='edit__icon' onClick={toggleEdit}></span>
                        </Tooltip>
                    </span>
                </div>
            </Form.Group>,

        select: <Form.Group as={Col}>
            <Form.Label style={{ fontWeight: "600" }}>{title}</Form.Label>
            <Select
                size="large"
                style={{ width: '100%' }}
                defaultValue={value}
                options={select}
                onChange={(val) => handleSelect(val, name)}
            />
        </Form.Group>
    };

    //@ts-ignore
    return components[type] || <></>;
};

InputCustom.propTypes = {
    title: string,
    name: string,
    type: string,
    asset_id: string,
    project_id: string,
    value: string,
    select: array,
    handleChange: func,
    handleSelect: func,
};

export default InputCustom;